import Axios from "axios";
import useAxios, {
  configure,
  loadCache,
  serializeCache,
  makeUseAxios
} from "axios-hooks";

const axios = Axios.create({
  baseURL: '/api'
});

configure({ axios });
